import { EnergyBar } from '../../../shared/components/EnergyBar'
import { PuzzleStage } from './PuzzleStage'
import { ConfirmedSegment } from '../../../shared/labs/transcript'

// The active play screen: the puzzle stage (numbers + transcript) with the energy bar
// between them and the Commit control underneath. No typing — the spoken transcript is
// the answer; the keypad only appears later if detection isn't confident.
export const PuzzleView = ({
  numbers,
  energy,
  speaking,
  dimmed,
  confirmedSegments,
  interimText,
  progressLabel,
  showNudge,
  onCommit,
  onPass,
}: {
  numbers: number[]
  energy: number
  speaking: boolean
  dimmed: boolean
  confirmedSegments: ConfirmedSegment[]
  interimText: string
  progressLabel?: string
  showNudge?: boolean
  onCommit: () => void
  onPass?: () => void
}) => (
  <PuzzleStage
    numbers={numbers}
    dimmed={dimmed}
    confirmedSegments={confirmedSegments}
    interimText={interimText}
    progressLabel={progressLabel}
    showNudge={showNudge}
    middle={<EnergyBar energy={energy} speaking={speaking} dimmed={dimmed} />}
  >
    <button
      type="button"
      onClick={onCommit}
      className="w-full rounded-lg bg-[#398874] py-3 text-white font-semibold leading-tight"
    >
      Commit answer
      <br />
      <span className="text-sm font-normal opacity-90">(or just say “commit”)</span>
    </button>
    {onPass && (
      <button
        type="button"
        onClick={onPass}
        className="mt-2 w-full rounded-lg border border-gray-200 py-2 text-sm font-medium text-gray-400 hover:bg-gray-50"
      >
        Pass
      </button>
    )}
    <p className="mt-2 text-center text-xs text-gray-400">
      {onPass ? 'You decide when to commit — up to 3 minutes per puzzle.' : 'Up to 3 minutes per puzzle.'}
    </p>
  </PuzzleStage>
)
